import { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import classes from './appointment.module.scss';

export default function Appointment() {
    const apiUrl = `${process.env.REACT_APP_BASE_URL}/mailing/BookAnAppointment`; // Replace with your API endpoint

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [company, setCompany] = useState('');
    const [currentPosition, setCurrentPosition] = useState('');
    const [preferredMethodOfContact, setPreferredMethodOfContact] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault(); // Prevent default form submission

        const requestBody = {
            firstName,
            lastName,
            email,
            phone,
            company,
            currentPosition,
            preferredMethodOfContact,
            message,
        };

        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody),
            });

            const responseData = await response.json();

            if (!responseData.failed) {
                toast.success("Your appointment request has been submitted. We'll contact you soon!");
                setFirstName('');
                setLastName('');
                setEmail('');
                setPhone('');
                setCompany('');
                setCurrentPosition('');
                setPreferredMethodOfContact('');
                setMessage('');
            } else {
                toast.error("An unexpected error occurred. Please try again later.");
            }
        } catch (error) {
            toast.error("Failed to submit your request. Please check your network connection.");
        }
    };

    return (
        <div className={classes.appointment}>
            <ToastContainer style={{zIndex: 99999}} position="top-center" autoClose={5000} hideProgressBar={true} closeOnClick pauseOnHover />

            <span className={classes.title}>Unlock the Potential of AI in Dentistry</span>
            <p className={classes.subtitle}>Register for Your Exclusive Demo</p>
            <form onSubmit={handleSubmit}>
                <div className={classes.formGroup}>
                    <input
                        type="text"
                        name='firstName'
                        placeholder="First Name"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                    />
                    <input
                        type="text"
                        name='lastName'
                        placeholder="Last Name"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        required
                    />
                </div>
                <div className={classes.formGroup}>
                    <input
                        type="email"
                        name='email'
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <input
                        type="tel"
                        name='phone'
                        placeholder="Phone"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        required
                    />
                </div>
                <div className={classes.formGroup}>
                    <input
                        type="text"
                        name='company'
                        placeholder="Company Name"
                        value={company}
                        onChange={(e) => setCompany(e.target.value)}
                        required
                    />
                    <input
                        type="text"
                        name='currentPosition'
                        placeholder="Current Position"
                        value={currentPosition}
                        onChange={(e) => setCurrentPosition(e.target.value)}
                        required
                    />
                </div>
                <div className={classes.contactMethod}>
                    <span>Preferred method of contact:</span>
                    <label>
                        <input
                            type="radio"
                            name="preferredMethodOfContact"
                            value="Email"
                            checked={preferredMethodOfContact === 'Email'}
                            onChange={(e) => setPreferredMethodOfContact(e.target.value)}
                        /> Email
                    </label>
                    <label>
                        <input
                            type="radio"
                            name="preferredMethodOfContact"
                            value="Phone"
                            checked={preferredMethodOfContact === 'Phone'}
                            onChange={(e) => setPreferredMethodOfContact(e.target.value)}
                        /> Phone
                    </label>
                </div>
                <div className={classes.formGroup}>
                    <textarea
                        placeholder="Outline your objectives:"
                        name='message'
                        rows={4}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        required
                    ></textarea>
                </div>
                <p>
                    By submitting this form, you consent to Implant Genius Enterprises Inc's Terms of Service and <a href='/privacy-policy' target='_blank'>Privacy Policy</a>.
                </p>
                <button type="submit" className={classes.submitButton}>Submit</button>
            </form>
        </div>
    );
}
